import { MediaCaption } from "../components/MediaCaption";

export function UseCaseVideo({
  embedUrl,
  title,
}: {
  embedUrl: string;
  title: string;
}) {
  return (
    <section className="px-[clamp(24px,5vw,80px)] pb-14">
      <div className="mx-auto max-w-[960px]">
        <div className="aspect-video overflow-hidden rounded-[28px] border border-indigo-200 bg-[#E5E2F4] shadow-[0_30px_60px_-30px_rgba(99,102,241,0.35)]">
          {embedUrl ? (
            <iframe
              src={embedUrl}
              title={title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="block h-full w-full border-0"
            />
          ) : (
            <div className="flex h-full w-full flex-col items-center justify-center gap-2 px-6 text-center">
              <div className="font-companion text-base font-semibold text-indigo-700">
                Video placeholder
              </div>
              <div className="font-body text-sm text-grindigo-600">
                Pass an embedUrl prop to UseCaseVideo.
              </div>
            </div>
          )}
        </div>
        <MediaCaption>
          This video is for demonstrative purposes only, not to provide clinical
          coaching or medical guidance in any way. Extreme or highly unlikely
          situations may be purposefully used to show the capability of the
          product.
        </MediaCaption>
      </div>
    </section>
  );
}
